"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = require("./container");
var executor_1 = require("./executor");
var react_1 = __importStar(require("react"));
var renderer_1 = require("./renderer");
function createModel(hook, hookArg) {
    var container = new container_1.Container(hook);
    renderer_1.render(react_1.default.createElement(executor_1.Executor, { onMount: function (val) {
            container.data = val;
        }, onUpdate: function (val) {
            container.data = val;
            container.notify();
        }, hook: function () { return hook(hookArg); } }));
    var useModel = function (depsFn) {
        var _a;
        var _b = __read(react_1.useState(function () {
            return container ? container.data : undefined;
        }), 2), state = _b[0], setState = _b[1];
        var depsFnRef = react_1.useRef(depsFn);
        depsFnRef.current = depsFn;
        var depsRef = react_1.useRef(((_a = depsFnRef.current) === null || _a === void 0 ? void 0 : _a.call(depsFnRef, container.data)) || []);
        react_1.useEffect(function () {
            if (!container)
                return;
            function subscriber(val) {
                if (!depsFnRef.current) {
                    setState(val);
                }
                else {
                    var oldDeps = depsRef.current;
                    var newDeps = depsFnRef.current(val);
                    if (compare(oldDeps, newDeps)) {
                        setState(val);
                    }
                    depsRef.current = newDeps;
                }
            }
            container.subscribers.add(subscriber);
            if (container.data !== state) {
                setState(container.data);
            }
            return function () {
                container.subscribers.delete(subscriber);
            };
        }, [container]);
        return state;
    };
    Object.defineProperty(useModel, "data", {
        get: function () {
            return container.data;
        }
    });
    return useModel;
}
exports.createModel = createModel;
function createLazyModel(hook, hookArg) {
    var useModel;
    var useLazyModel = function (depsFn) {
        if (!useModel) {
            useModel = createModel(hook, hookArg);
        }
        return useModel(depsFn);
    };
    Object.defineProperty(useLazyModel, "data", {
        get: function () {
            return useModel === null || useModel === void 0 ? void 0 : useModel.data;
        }
    });
    return useLazyModel;
}
exports.createLazyModel = createLazyModel;
function compare(oldDeps, newDeps) {
    if (oldDeps.length !== newDeps.length) {
        return true;
    }
    for (var index in newDeps) {
        if (oldDeps[index] !== newDeps[index]) {
            return true;
        }
    }
    return false;
}
